import { render, staticRenderFns } from "./SaleInvoiceCollectCreationModal.vue?vue&type=template&id=6b39e5cf&scoped=true&"
import script from "./SaleInvoiceCollectCreationModal.vue?vue&type=script&lang=js&"
export * from "./SaleInvoiceCollectCreationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b39e5cf",
  null
  
)

export default component.exports